(() => {
  const { gsap, ScrollTrigger, DrawSVGPlugin } = window;

  if (!gsap) return;

  gsap.defaults({
    ease: 'power4.out'
  });
  gsap.config({
    nullTargetWarn: false
  });

  const plugins = [ScrollTrigger, DrawSVGPlugin].filter(Boolean);
  if (plugins.length) {
    gsap.registerPlugin(...plugins);
  }
})();
